module.exports = __webpack_public_path__ + "frontend/images/favicons/mstile-70x70.png?2a0a1c2800a12eb303fcd083e5527430";